import api from '../../utils/api';
import { Dispatch } from 'redux';
import { Schedule } from '@types';
import {
  addSchedule,
  editSchedule,
  removeSchedule,
  setSchedules,
} from '../reducers/schedule';

export const formatScheduleData = (data: Partial<Schedule>): Schedule => {
  const start = new Date(data.start || data.startTime || '');
  const end = new Date(data.end || data.endTime|| '');
  const hoursDifference = (end.getTime() - start.getTime()) / (1000 * 60 * 60);

  return {
    ...data,
    Start: start,
    End: end,
    Patient: data.patient?.id,
    Note: data.note,
    Department: data.department?.id,
    isAllDay: hoursDifference >= 6,
  } as Schedule;
};

export const getSchedules = (hspCd: string) => {
  return async (dispatch: Dispatch) => {

    try {
      const response = await api.getSchedulesAsync(hspCd);
      if (!response.data || response.data.length === 0) {
        dispatch(setSchedules([]));
      } else {
        const formattedData = response.data.map((item: Partial<Schedule>) =>
          formatScheduleData(item)
        );
        dispatch(setSchedules(formattedData));
      }
      return response.data;
    } catch (error) {
      console.error('error 내용', error);
    }
  };
};


export const registerSchedule = (schedule: Schedule) => async (dispatch: Dispatch) => {
    const response = await api.postScheduleAsync(schedule);
    const formattedData = formatScheduleData(response.data);
    dispatch(addSchedule(formattedData));
  };

export const updateSchedule = (schedule: Schedule) => async (dispatch: Dispatch) => {

    const response = await api.updateScheduleAsync(schedule);
    const formattedData = formatScheduleData(response.data);
    dispatch(editSchedule(formattedData));
  };

export const deleteSchedule = (id: number) => async (dispatch: Dispatch) => {
    await api.deleteScheduleAsync(id);
    dispatch(removeSchedule(id));
};
